import React, { useState } from "react";
import "./GarageSetup.scss";

export default function GarageSetup({ onSetupComplete }) {
  const [garage, setGarage] = useState({
    id: "",
    name: "",
    location: "",
    capacity: "",
    contact: "",
  });

  const handleChange = (e) => {
    setGarage({ ...garage, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!garage.name || !garage.id) {
      alert("Garage ID and Name are required!");
      return;
    }

    // ✅ Save garage data to sessionStorage
    sessionStorage.setItem("garageData", JSON.stringify(garage));

    // ✅ Add this flag
sessionStorage.setItem("garageSetupComplete", "true");

    // ✅ Call parent callback to redirect to ChatbotWidget
    if (onSetupComplete) onSetupComplete(garage);
  };

  return (
    <div className="garage-setup">
      <h2>🏗️ Garage Setup</h2>
      <p className="subtitle">
        Enter your garage details to personalize Parky
      </p>
      <form onSubmit={handleSubmit}>
        <label>Garage ID *</label>
        <input name="id" value={garage.id} onChange={handleChange} required />

        <label>Garage Name *</label>
        <input name="name" value={garage.name} onChange={handleChange} required />

        <label>Location</label>
        <input name="location" value={garage.location} onChange={handleChange} />

        <label>Contact Info</label>
        <input name="contact" value={garage.contact} onChange={handleChange} />

        <button type="submit" className="setup-btn">
          Save & Continue →
        </button>
      </form>
    </div>
  );
}
